module.exports = __webpack_public_path__ + "img/Kia.7d7998f0.jpg";